import React from 'react';
import { motion } from 'framer-motion';

const AnimatronicsInFilm = () => {
  return (
    <section className="prose prose-invert max-w-none">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="order-2 md:order-1"
        >
          <img
            src="/images/film-animatronics.webp"
            alt="Iconic film animatronics through history"
            className="w-full rounded-lg"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="order-1 md:order-2"
        >
          <h2 className="text-2xl font-bold mb-6">Animatronics in Film</h2>
          <p className="text-lg leading-relaxed">
            Although our database excludes film and television animatronics, the influence of iconic movie creations has been pivotal to the history and evolution of animatronics. From the roaring, life-sized T-Rex in Jurassic Park to the terrifying, fluid movements of the Xenomorph in Alien, these cinematic achievements pushed the boundaries of what animatronics could accomplish. Such figures were not merely props but integral parts of storytelling, demonstrating groundbreaking engineering that often laid the groundwork for advancements in permanent themed installations.
          </p> 
          <p className="text-lg leading-relaxed">
            Jabba the Hutt from Star Wars: Return of the Jedi is another prime example of animatronic innovation in cinema. Operated by a team of puppeteers and loaded with intricate mechanical components, Jabba showcased a combination of artistry and engineering that made him a memorable and convincing character. Similarly, the giant ape animatronic in the original King Kong remake (1976) displayed a level of realism that was unprecedented at the time, inspiring future applications in theme parks and live entertainment.
          </p> 
          <p className="text-lg leading-relaxed">
            Even more recent examples, such as the animatronic baby Yoda (The Mandalorian) and the practical Velociraptors in Jurassic World, continue to demonstrate how animatronics in film can create a level of tangibility that CGI often struggles to achieve. These cinematic achievements don't just captivate audiences on screen—they influence the design and capabilities of animatronics used in theme parks, museums, and other entertainment venues, blurring the line between imagination and reality.
          </p>
        </motion.div>
      </div>
    </section>
  );
}

export default AnimatronicsInFilm;